import SubtitleTotals from './SubtitleTotals'

export default SubtitleTotals
